export type ReportReadyDetail = {
  reportId: string;
  status: "published" | "failed" | string;
  message?: string;
  action?: string;
};

export const REPORTS_READY_EVENT = "reports:ready";

export function dispatchReportReady(detail: ReportReadyDetail): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent<ReportReadyDetail>(REPORTS_READY_EVENT, { detail }));
}

export function subscribeReportReady(handler: (detail: ReportReadyDetail) => void): () => void {
  if (typeof window === "undefined") return () => undefined;

  const listener = (e: Event) => {
    const ce = e as CustomEvent<ReportReadyDetail>;
    if (ce.detail?.reportId) handler(ce.detail);
  };
  window.addEventListener(REPORTS_READY_EVENT, listener);
  return () => window.removeEventListener(REPORTS_READY_EVENT, listener);
}
